module.exports = __webpack_public_path__ + "img/tt.57e87020.png";